import routerOptions0 from "/builds/campinginfo/civ2-nuxt-3/node_modules/.pnpm/nuxt@3.17.6_@netlify+blobs@8.2.0_@parcel+watcher@2.5.0_@types+node@22.15.21_@vue+compil_938c889c7b170f2c207e34f0f6c786d5/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/builds/campinginfo/civ2-nuxt-3/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}